export default __webpack_public_path__ + "static/media/settlements.d6793c64.svg";